var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingPhoneBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 735,
    height: 260,
    viewBox: "0 0 735 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M698.5 227C462.5 25 327.656 403.752 317.551 163C310.5 -5 206.106 143.949 135.051 41.5",
    stroke: "#F9E9E2",
    strokeWidth: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M724.5 248C520.5 -17 329.551 342.5 338.551 165C347.551 -12.5 214.551 116.212 6 12",
    stroke: "white",
    strokeWidth: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingPhoneBackgroundIcon);
export default __webpack_public_path__ + "static/media/onboarding-phone-background-icon.103c299bff77b7a5751a93940da82b80.svg";
export { ForwardRef as ReactComponent };